import ja from './lang/ja';
import en from './lang/en';

export default {
  ja,
  en,
};